var _colorProfile;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAir2Website(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    id: "svg1",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "swatch15"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#33ae33",
      stopOpacity: 1
    },
    offset: 0,
    id: "stop15"
  })), _colorProfile || (_colorProfile = /*#__PURE__*/React.createElement("colorProfile", {
    name: "Lab2Lab",
    xlinkHref: "file:///snap/inkscape/10555/usr/share/color/icc/ghostscript/lab.icc",
    id: "color-profile2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    style: {
      display: "inline",
      opacity: 1,
      mixBlendMode: "normal",
      fill: "#ffffff",
      fillOpacity: 0
    }
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 0,
      strokeWidth: 2.22992,
      paintOrder: "markers stroke fill"
    },
    id: "rect1",
    width: 48.04158,
    height: 47.957115,
    x: -0.017678654,
    y: 0.10133093
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      mixBlendMode: "normal",
      fill: "#ffffff",
      fillOpacity: 0.00006156,
      strokeWidth: 2.22992,
      paintOrder: "markers stroke fill"
    },
    id: "rect1-8",
    width: 48.04158,
    height: 47.957115,
    x: -0.049031824,
    y: 0.033099473,
    transform: "rotate(-0.0733964)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer3"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#dbffff",
      fillOpacity: 1,
      strokeWidth: 2.22992,
      paintOrder: "markers stroke fill"
    },
    d: "M 10.83535,12.040256 C 4.8170677,8.8160934 -1.7584673,4.4172168 12.853042,11.253926 7.1556555,6.3878157 7.3946035,6.3009268 16.444553,11.926359 15.24821,10.176296 5.0684507,4.3849049 19.668372,11.31413 16.238158,9.5773774 15.404667,5.836103 26.739675,13.608131 21.602991,8.6125704 16.539646,4.4669094 29.199191,11.515772 c -4.989077,-4.6668311 2.445653,-0.07058 4.901209,3.077022 7.442472,1.616932 12.821085,6.34917 -0.06326,1.847781 7.899885,2.811835 15.964172,7.446651 -0.256736,3.071229 14.546989,6.430233 -2.139883,4.093237 -6.234519,0.104359 -2.412831,-1.333083 -11.141178,-6.064169 2.180578,-3.738352 -1.055756,0.01562 -0.872881,0.165953 -1.031049,-0.212031 0.03697,1.408745 -7.283806,-2.85529 -1.969108,4.278094 1.235299,2.065267 -5.676874,-3.76708 -6.532471,-4.939352 4.166967,5.710406 7.591257,7.589859 -3.980397,1.168394 9.661402,7.552883 -2.42813,0.630732 -3.878074,-0.951935 C 28.041948,27.88694 23.246596,24.026215 8.4905095,15.880559 -1.7925303,9.0895514 7.9332225,13.609334 10.83535,12.040256 Z",
    id: "path15"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer2",
    style: {
      opacity: 1,
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "40.411px",
      fontFamily: "'Ubuntu Mono'",
      InkscapeFontSpecification: "'Ubuntu Mono'",
      whiteSpace: "pre",
      inlineSize: 0,
      opacity: 1,
      fill: "#82b74b",
      fillOpacity: 1,
      strokeWidth: 2.22577,
      paintOrder: "markers stroke fill"
    },
    x: 21.92115,
    y: 36.410946,
    id: "text1",
    transform: "matrix(0.96393006,0.29187838,-0.29034586,0.9588689,-1.0581904,-9.8451548)"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan1",
    x: 21.92115,
    y: 36.410946,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "40.411px",
      fontFamily: "Kinnari",
      InkscapeFontSpecification: "Kinnari",
      fill: "#82b74b",
      fillOpacity: 1,
      strokeWidth: 2.22577
    }
  }, "A"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAir2Website);
export default __webpack_public_path__ + "static/media/air2-website.7c8dbe29af8b298c28f757c4698f66dc.svg";
export { ForwardRef as ReactComponent };